export enum EState {
  getStates = 'state/getStates',
  getStatesByCountry = 'state/getStatesByCountry',
  getState = 'state/getState',
  createState = 'state/createState',
  updateState = 'state/updateState',
  deleteState = 'state/deleteState',
}
